import { internalMessageBus, InternalMessageBusChannels } from "sb-internal-msg-bus";
import { SportDataGateway } from "sb-bff-integration";
import { AggregatedEventsRetriever, AggregatedEventsParser } from "./AggregatedEvents";
import { IncidentsParser, IncidentsRetriever } from "./Incidents";
let _localMocks;
let aggregatedEventMock;
if (process.env.NODE_ENV === "development") {
    _localMocks = require("./Mocks");
    aggregatedEventMock = _localMocks.aggregated_event_add;
}
export class AggregatesData {
    constructor(langCode, msgBus, timeFormat) {
        let data = {};
        this.aggregatedEventsParser = {};
        this.activate = this.activate.bind(this);
        this.deactivate = this.deactivate.bind(this);
        if (process.env.NODE_ENV === "development") {
            data = {
                languageCode: "en",
                messageBus: internalMessageBus,
                gateway: new _localMocks.SportDataGatewayMock(_localMocks.mockFeedsObject)
            };
            this.aggregatedEventsParser = new AggregatedEventsParser(new AggregatedEventsRetriever(data), "HH:mm");
            internalMessageBus.emit(InternalMessageBusChannels.aggregatedEvents.retrieval.activate, {});
        }
        if (process.env.NODE_ENV === "production") {
            data = {
                languageCode: langCode,
                messageBus: msgBus,
                gateway: new SportDataGateway()
            };
            this.aggregatedEventsParser = new AggregatedEventsParser(new AggregatedEventsRetriever(data), timeFormat);
        }
        data.messageBus.on(InternalMessageBusChannels.aggregatedEvents.retrieval.activate, this.activate);
        data.messageBus.on(InternalMessageBusChannels.aggregatedEvents.retrieval.deactivate, this.deactivate);
        this.incidentsParser = new IncidentsParser(new IncidentsRetriever(data));
        if (process.env.NODE_ENV === "development") {
            internalMessageBus.emit(InternalMessageBusChannels.aggregatedEvents.currentId.update, { currentAggregatedId: aggregatedEventMock.id });
        }
    }
    activate() {
        this.aggregatedEventsParser.activate();
        this.incidentsParser.activate();
    }
    deactivate() {
        this.aggregatedEventsParser.deactivate();
        this.incidentsParser.deactivate();
    }
}
//# sourceMappingURL=index.js.map